import axios from 'src/store/vue-axios/axios.js'

export default class Management {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SCHOOL_TYPES -> /management/school-types*
  static schoolTypesUrl = () => '/management/school-types'

  // QUOTATION -> /management/quotations/${leadUuid}*
  static quotationsUrl = (leadUuid) => `/management/quotations/${leadUuid}`

  // CONTRACTS -> /management/schools/${schoolUuid}/contracts*
  static schoolContractsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/contracts`
  static schoolContractsInvoiceUrl = (schoolUuid, contractUuid) => `/management/schools/${schoolUuid}/contracts/${contractUuid}/invoice`

  // CSV-USERS -> /management/schools/${schoolUuid}/csv-users*
  static csvUsersUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-users`

  // CSV-IMPORT -> /management/schools/${schoolUuid}/csv-import*
  static csvImportUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import`
  static csvImportStatusUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/status`
  static csvImportExtractTTEntitiesUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/extract-timetable-entities`
  static csvImportPublishTimetableUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/publish-timetable-entities`
  static csvImportSaveChangesUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/save`
  static csvImportDeleteUserUrl = (schoolUuid, userId) => `/management/schools/${schoolUuid}/csv-import/delete/${userId}`
  static csvImportMergeUserUrl = (schoolUuid, userId) => `/management/schools/${schoolUuid}/csv-import/merge/${userId}`
  static csvImportParentsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/parents?`
  static csvImportParentsKeepUrl = (schoolUuid, userId) => `/management/schools/${schoolUuid}/csv-import/parents/keep/${userId}`
  static csvImportKeepUrl = (schoolUuid, userId) => `/management/schools/${schoolUuid}/csv-import/keep/${userId}`
  static csvUsersImportUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/csv-users`
  static csvImportSearchUsersUrl = (schoolUuid, searchVal) => `/management/schools/${schoolUuid}/csv-import/csv-users?search=${searchVal}`
  static csvImportUnmatchingUsersPaginatedUrl = (schoolUuid, page, searchVal) => `/management/schools/${schoolUuid}/csv-import/csv-users?unmatched=true&page=${page}&search=${searchVal}&direction=ASC`
  static csvImportAutoMatchingUsersUrl = (schoolUuid, automatched) => `/management/schools/${schoolUuid}/csv-import/matching-users?automatched=${automatched}&`
  static csvImportAutoMatchingUsersPaginatedUrl = (schoolUuid, page, searchVal, automatched) => `/management/schools/${schoolUuid}/csv-import/matching-users?page=${page}&search=${searchVal}&automatched=${automatched}&`
  static csvImportMatchingUsersUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/matching-users?`
  static csvImportSearchMatchingUsersUrl = (schoolUuid, searchVal) => `/management/schools/${schoolUuid}/csv-import/matching-users?search=${searchVal}`
  static csvImportUsersUrl = (schoolUuid) => `/management/schools/${schoolUuid}/csv-import/import-users`

  // BULK -> /management/schools/${schoolUuid}/bulks*
  static bulksUrl = (schoolUuid) => `/management/schools/${schoolUuid}/bulks`
  static singleBulkUrl = (schoolUuid, bulkId) => `/management/schools/${schoolUuid}/bulks/${bulkId}`
  static revertBulkUrl = (schoolUuid, bulkUuid) => `/management/schools/${schoolUuid}/bulks/${bulkUuid}/revert`

  // SCHOOL -> /management/schools/*
  static schoolsCreateUrl = () => '/management/schools'
  static schoolSettingsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/properties`
  static duplicatedUsersUrl = (schoolUuid, page, search) => `/management/schools/${schoolUuid}/duplicated-users?page=${page}&search=${search}`
  static usersDuplicatedUrl = (schoolUuid) => `/management/schools/${schoolUuid}/users/duplicated`
  static timetableEventsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/timetable-events?`
  static uploadsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/uploads`
  static logoUrl = (schoolUuid) => `/management/schools/${schoolUuid}/logo`
  static policiesUrl = (schoolUuid) => `/management/schools/${schoolUuid}/policies`
  static exportsUrl = (schoolUuid, classbookId) => `/management/schools/${schoolUuid}/classbooks/${classbookId}/exports`
  static createExportsUrl = (schoolUuid, classbookId) => `/management/schools/${schoolUuid}/classbooks/${classbookId}/exports/create`
  static createIdmConnectorSyncUrl = (schoolUuid) => `/management/schools/${schoolUuid}/idm-connector/sync`
  static createIDPRealm = (schoolUuid) => `/management/schools/${schoolUuid}/idp`
  static ldapMigrationGenerateExportUrl = (schoolUuid) => `/management/schools/${schoolUuid}/ldap/migration/generate`
  static ldapMigrationImportUrl = (schoolUuid) => `/management/schools/${schoolUuid}/ldap/migration/import`

  // AUTH_DRIVER -> /management/schools/${schoolUuid}/authdrivers*
  static authDriverSettingsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/authdrivers`
  static authDriverTypesUrl = (schoolUuid) => `/management/schools/${schoolUuid}/authdrivers/drivers`
  static testAuthDriverSettingsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/authdrivers/test`
  static ldapSyncUrl = (schoolUuid) => `/management/schools/${schoolUuid}/authdrivers/ldap/sync`
  static sourceDrivers = (search) => `management/sources?search=${search}`
  static sourceDriverById = (driverId) => `management/sources/${driverId}`
  static schoolSource = (schoolId) => `/management/schools/${schoolId}/source`
  static bidSchoolSource = (schoolId) => `${this.schoolSource(schoolId)}/bid`
  static authSourceSettings = (schoolUuid) => `/management/schools/${schoolUuid}/authdrivers/sources`

  // DATASYNC -> /management/data-sync/

  static dataSyncODS = (schoolUuid) => `/management/schools/${schoolUuid}/data-sync`

  // SourceDrivers -> /management/data-sync/
  static sourceDriver = () => '/webhooks/sources/credentials-internal'

  // EDUCA -> /management/schools/${schoolUuid}/educa
  static educaSchoolUrl = (schoolUuid) => `/management/schools/${schoolUuid}/educa`
  static educaSevenTimetableSchoolUrl = (schoolUuid) => `/management/schools/${schoolUuid}/educa/timetable`

  // IAM Tenant Management
  static iamTenantGet = (schoolUuid) => `/management/schools/${schoolUuid}/iam/tenant`
  static iamTenantCreate = (schoolUuid) => `/management/schools/${schoolUuid}/iam/tenant`
  static iamTenantUpdate = (schoolUuid) => `/management/schools/${schoolUuid}/iam/tenant`
  static iamTenantDisable = (schoolUuid) => `/management/schools/${schoolUuid}/iam/tenant/disable`
  static iamTenantRegisterClient = (schoolUuid) => `/management/schools/${schoolUuid}/iam/tenant/register-client`
  static platformEnable = (schoolUuid) => `/management/schools/${schoolUuid}/platform/enable`
  static platformDisable = (schoolUuid) => `/management/schools/${schoolUuid}/platform/disable`

  // ENCRYPTION -> /management/schools/${schoolUuid}/encryption*
  static encryptionConfigurationUrl = (schoolUuid) => `/management/schools/${schoolUuid}/encryption/configuration`
  static encryptionAvailableConfigurationsUrl = (schoolUuid) => `/management/schools/${schoolUuid}/encryption/configurations/available`
  static encryptionMigrationUrl = (schoolUuid) => `/management/schools/${schoolUuid}/encryption/migration`
  static encryptionDEKRotationUrl = (schoolUuid) => `/management/schools/${schoolUuid}/encryption/deks/rotate`
  static encryptionDEKRewrapUrl = (schoolUuid) => `/management/schools/${schoolUuid}/encryption/deks/rewrap`

  // SCHOOL PROPERTIES

  static schoolPropertiesUrl = () => 'management/schools/properties'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SCHOOL_TYPES -> /management/school-types*
  static async getSchoolTypes () {
    return axios.get(this.schoolTypesUrl())
  }

  // QUOTATION -> /management/quotations/${leadUuid}*
  static async postQuotation (leadUuid, payload) {
    return axios.post(this.quotationsUrl(leadUuid), payload)
  }

  // CONTRACTS -> /management/schools/${schoolUuid}/contracts*
  static async postSchoolContracts (schoolUuid, payload) {
    return axios.post(this.schoolContractsUrl(schoolUuid), payload)
  }

  static async postSchoolContractsInvoice (schoolUuid, contractUuid, payload) {
    return axios.post(this.schoolContractsInvoiceUrl(schoolUuid, contractUuid), payload)
  }

  // CSV-USERS -> /management/schools/${schoolUuid}/csv-users*
  static async postCsvUsers (uuid, payload, config) {
    return axios.post(this.csvUsersUrl(uuid), payload, config)
  }

  // CSV -> /management/schools/${schoolUuid}/csv-import*
  static async getCsvImportStatus (uuid) {
    return axios.get(this.csvImportStatusUrl(uuid))
  }

  static async postCsvImportExtractTTEntities (uuid, payload, config) {
    return axios.post(this.csvImportExtractTTEntitiesUrl(uuid), payload, config)
  }

  static async postCsvImportPublishTimetable (uuid, payload, config) {
    return axios.post(this.csvImportPublishTimetableUrl(uuid), payload, config)
  }

  static async deleteCsvImport (uuid) {
    return axios.delete(this.csvImportUrl(uuid))
  }

  static async postCsvImportKeepParentUsers (schoolUuid, userId, isKept = false) {
    return axios.post(this.csvImportParentsKeepUrl(schoolUuid, userId), { is_kept: isKept })
  }

  static async postCsvImportKeepUsers (schoolUuid, userId) {
    return axios.post(this.csvImportKeepUrl(schoolUuid, userId))
  }

  static async getCsvImportSearchUsers (schoolUuid, searchVal, config) {
    return axios.get(this.csvImportSearchUsersUrl(schoolUuid, searchVal), config)
  }

  static async getCsvImportSearchMatchingUsers (schoolUuid, searchVal, config) {
    return axios.get(this.csvImportSearchMatchingUsersUrl(schoolUuid, searchVal), config)
  }

  static async postCsvImportUsers (schoolUuid, payload, config) {
    return axios.post(this.csvImportUsersUrl(schoolUuid), payload, config)
  }

  static async getCsvImportAutoMatchingUsersPaginated (schoolUuid, page, searchVal, automatched) {
    return axios.get(this.csvImportAutoMatchingUsersPaginatedUrl(schoolUuid, page, searchVal, automatched), {
      // wait longer than normal, 5 min
      timeout: 5 * 60 * 1000
    })
  }

  static async getCsvImportUnmatchingUsersPaginated (schoolUuid, page, searchVal) {
    return axios.get(this.csvImportUnmatchingUsersPaginatedUrl(schoolUuid, page, searchVal))
  }

  static async putCsvImportSaveChanges (uuid) {
    return axios.put(this.csvImportSaveChangesUrl(uuid), {}, {
      // wait longer than normal
      timeout: 5 * 60 * 1000
    })
  }

  static async deleteCsvImportDeleteUser (schoolUuid, userId) {
    return axios.delete(this.csvImportDeleteUserUrl(schoolUuid, userId))
  }

  static async postCsvImportMergeUser (schoolUuid, userId, payload) {
    return axios.post(this.csvImportMergeUserUrl(schoolUuid, userId), payload)
  }

  // BULK -> /management/schools/${schoolUuid}/bulks*
  static async getBulks (uuid) {
    return axios.get(this.bulksUrl(uuid))
  }

  static async getSingleBulk (schoolUuid, bulkId) {
    return axios.get(this.singleBulkUrl(schoolUuid, bulkId))
  }

  static async putRevertBulk (uuid, bulkUuid) {
    return axios.put(this.revertBulkUrl(uuid, bulkUuid))
  }

  // SCHOOL -> /management/schools/*
  static async postCreateSchool (payload) {
    return axios.post(this.schoolsCreateUrl(), payload)
  }

  // EDUCA -> /management/schools/${schoolUuid}/educa
  static async postCreateEducaSchool (schoolUuid) {
    return axios.post(this.educaSchoolUrl(schoolUuid))
  }

  static async postCreateEducaSevenTimetableSchool (schoolUuid) {
    return axios.post(this.educaSevenTimetableSchoolUrl(schoolUuid))
  }

  static async getUploads (schoolUuid) {
    return axios.get(this.uploadsUrl(schoolUuid))
  }

  static async postLogo (schoolUuid, payload, config) {
    return axios.post(this.logoUrl(schoolUuid), payload, config)
  }

  static async getPolicies (schoolUuid) {
    return axios.get(this.policiesUrl(schoolUuid))
  }

  static async postPolicies (schoolUuid, payload) {
    return axios.post(this.policiesUrl(schoolUuid), payload)
  }

  static async getExports (schoolUuid, classbookId) {
    return axios.get(this.exportsUrl(schoolUuid, classbookId))
  }

  static async postCreateExport (schoolUuid, classbookId) {
    return axios.post(this.createExportsUrl(schoolUuid, classbookId))
  }

  static async postSyncIdmConnector (schoolUuid) {
    return axios.post(this.createIdmConnectorSyncUrl(schoolUuid))
  }

  static async postCreateIDPRealm (schoolUuid) {
    return axios.post(this.createIDPRealm(schoolUuid))
  }

  static async getTimetableEvents (uuid) {
    return axios.get(this.timetableEventsUrl(uuid))
  }

  static async getDuplicatedUsers (uuid, page, search = '') {
    return axios.get(this.duplicatedUsersUrl(uuid, page, search))
  }

  static async getUsersDuplicated (schoolUuid) {
    return axios.get(this.usersDuplicatedUrl(schoolUuid))
  }

  static async getSchoolSettings (uuid) {
    return axios.get(this.schoolSettingsUrl(uuid))
  }

  static async putSchoolSettings (uuid, data, config = {}) {
    return axios.put(this.schoolSettingsUrl(uuid), data, config)
  }

  // AUTH_DRIVER -> /management/schools/${schoolUuid}/authdrivers*
  static async getAuthDriverTypes (uuid) {
    return axios.get(this.authDriverTypesUrl(uuid))
  }

  static async getAuthDriverSettings (uuid) {
    return axios.get(this.authDriverSettingsUrl(uuid))
  }

  static async postTestAuthDriverSettings (uuid) {
    return axios.post(this.testAuthDriverSettingsUrl(uuid))
  }

  static async postLdapSync (uuid) {
    return axios.post(this.ldapSyncUrl(uuid))
  }

  static async putAuthDriverSettings (uuid, data) {
    return axios.put(this.authDriverSettingsUrl(uuid), data)
  }

  static async deleteAuthDriverSettings (uuid) {
    return axios.delete(this.authDriverSettingsUrl(uuid))
  }

  static async putSourceDriverToSchool (schoolId, payload) {
    return axios.put(this.schoolSource(schoolId), payload)
  }

  // A 404 here just means "no source driver linked yet", so it must not surface as an error toast.
  static async getSchoolSourceDriver (schoolId) {
    return axios.get(this.schoolSource(schoolId), { showMessages: false })
  }

  static async postBidSourceDriver (schoolId, payload) {
    return axios.post(this.bidSchoolSource(schoolId), payload)
  }

  static async getSourceDrivers (search = null) {
    return axios.get(this.sourceDrivers(search))
  }

  static async getSourceDriverById (driverId) {
    return axios.get(this.sourceDriverById(driverId))
  }

  static async putAuthSourceSettings (uuid, data) {
    return axios.put(this.authSourceSettings(uuid), data)
  }

  static async postDataSyncODS (uuid) {
    return axios.post(this.dataSyncODS(uuid))
  }

  static async postSourceDriver (data) {
    return axios.post(this.sourceDriver(), data)
  }

  static async getSchoolProperties () {
    return axios.get(this.schoolPropertiesUrl())
  }

  // These are endpoints related to IAM
  static async getIamTenant (uuid) {
    return axios.get(this.iamTenantGet(uuid))
  }

  static async postCreateIamTenant (uuid) {
    return axios.post(this.iamTenantCreate(uuid))
  }

  static async putIamTenant (uuid, payload) {
    return axios.put(this.iamTenantUpdate(uuid), payload)
  }

  static async postDisableIamTenant (uuid) {
    return axios.post(this.iamTenantDisable(uuid))
  }

  static async postIamTenantRegisterClient (uuid, payload) {
    return axios.post(this.iamTenantRegisterClient(uuid), payload)
  }

  static async postEnablePlatformSync (uuid) {
    return axios.post(this.platformEnable(uuid))
  }

  static async postDisablePlatformSync (uuid) {
    return axios.post(this.platformDisable(uuid))
  }

  static async postLdapMigrationGenerateExport (uuid, payload = {}) {
    return axios.post(this.ldapMigrationGenerateExportUrl(uuid), payload)
  }

  static async postLdapMigrationImport (uuid, payload, config) {
    return axios.post(this.ldapMigrationImportUrl(uuid), payload, config)
  }

  // ENCRYPTION -> /management/schools/${schoolUuid}/encryption*
  static async getCurrentEncryptionConfiguration (schoolUuid) {
    return axios.get(this.encryptionConfigurationUrl(schoolUuid))
  }

  static async getAvailableEncryptionConfigurations (schoolUuid) {
    return axios.get(this.encryptionAvailableConfigurationsUrl(schoolUuid))
  }

  static async selectEncryptionConfiguration (schoolUuid, payload) {
    return axios.post(this.encryptionConfigurationUrl(schoolUuid), payload)
  }

  static async queueMessageMigration (schoolUuid) {
    return axios.post(this.encryptionMigrationUrl(schoolUuid))
  }

  static async cancelMessageMigration (schoolUuid) {
    return axios.delete(this.encryptionMigrationUrl(schoolUuid))
  }

  static async triggerDEKRotation (schoolUuid) {
    return axios.post(this.encryptionDEKRotationUrl(schoolUuid))
  }

  static async triggerDEKRewrap (schoolUuid) {
    return axios.post(this.encryptionDEKRewrapUrl(schoolUuid))
  }
}
